<template>
  <div
    id="komstore-onboarding-container"
    class="h-screen bg-white"
  >
    <iframe
      frameborder="1"
      height="100%"
      width="100%"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/online-store/onboarding`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
import secureLs from '@/libs/secureLs'

export default {
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
    }
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
    document.body.classList.add('hide-footer')
  },
  beforeDestroy() {
    window.removeEventListener('message', this.watchIframe)
    document.body.classList.remove('hide-footer')
  },
  methods: {
    updateUserDataOnboarding() {
      try {
        const currentUser = secureLs.getItem('userData')
        if (currentUser) {
          currentUser.is_onboarding_komstore = 1
          secureLs.setItem('userData', JSON.stringify(currentUser))
        }
      } catch (e) {
        console.error('Failed to update secureLs userData:', e)
      }

      try {
        const rawUserData = localStorage.getItem('userData')
        if (rawUserData) {
          const parsed = JSON.parse(rawUserData)
          parsed.is_onboarding_komstore = 1
          localStorage.setItem('userData', JSON.stringify(parsed))
        }
      } catch (e) {
        console.error('Failed to update localStorage userData:', e)
      }

      try {
        const legacyDataStr = localStorage.getItem('legacy_userData')
        if (legacyDataStr) {
          const parsed = JSON.parse(legacyDataStr)
          parsed.is_onboarding_komstore = 1
          localStorage.setItem('legacy_userData', JSON.stringify(parsed))
        }
      } catch (e) {
        console.error('Failed to update localStorage legacy_userData:', e)
      }

      try {
        this.$store.dispatch('dashboard/getProfile')
      } catch (e) {
        console.error('Failed to dispatch getProfile:', e)
      }
    },
    watchIframe(event) {
      const isSuccessMsg = event.data === 'success_onboarding_komstore'
        || event.data?.type === 'success_onboarding_komstore'
        || event.data?.type === 'ONBOARDING_COMPLETED'
        || (event.data?.type === 'navigate' && event.data?.route?.includes('online-store'))

      if (isSuccessMsg) {
        this.updateUserDataOnboarding()
        const targetRoute = event.data?.route || { name: 'online-store-management' }
        this.$router.push(targetRoute)
        return
      }

      if (event.data?.type === 'navigate' && event.data?.route) {
        this.$router.push(event.data.route)
      }
    },
  },
}
</script>

<style>
body.hide-footer .footer {
  display: none !important;
}
</style>
